(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-cart-form]');
    if (!form) return;

    const quantityInputs = Array.from(form.querySelectorAll('input[data-cut-group][data-cut-role]'));
    quantityInputs
      .filter((input) => input.dataset.cutRole === 'product')
      .forEach((productInput) => {
        const serviceInput = quantityInputs.find((input) => input.dataset.cutGroup === productInput.dataset.cutGroup && input.dataset.cutRole === 'service');
        if (serviceInput) serviceInput.value = productInput.value;
      });
  });

  document.addEventListener('click', async (event) => {
    const removeLink = event.target.closest('[data-cart-remove][data-cut-group]');
    if (!removeLink) return;

    const form = removeLink.closest('[data-cart-form]');
    if (!form) return;

    const pairedLinks = Array.from(form.querySelectorAll('[data-cart-remove][data-cut-group]'))
      .filter((link) => link.dataset.cutGroup === removeLink.dataset.cutGroup);

    if (pairedLinks.length < 2) return;

    event.preventDefault();

    const updates = {};
    pairedLinks.forEach((link) => {
      updates[link.dataset.itemKey] = 0;
    });

    try {
      const response = await fetch(form.dataset.cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });

      if (!response.ok) throw new Error('cart');

      window.location.href = form.dataset.cartUrl;
    } catch (error) {
      window.location.href = removeLink.href;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-iberico"]) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;

    const checkbox = form.querySelector('[data-hand-cut-checkbox]');
    if (!checkbox || !checkbox.checked) return;

    const serviceId = form.dataset.handCutServiceId;
    if (!serviceId) return;

    event.preventDefault();

    const submitButton = event.submitter;
    const errorMessage = form.querySelector('[data-hand-cut-error]');
    if (errorMessage) errorMessage.hidden = true;
    if (submitButton) submitButton.disabled = true;

    const data = new FormData(form);
    const variantId = Number(data.get('id'));
    const quantity = Number(data.get('quantity') || 1);
    const properties = {};

    data.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value) properties[match[1]] = String(value);
    });

    const groupId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    properties._corte_grupo = groupId;

    const payload = {
      items: [
        { id: variantId, quantity: quantity, properties: properties },
        { id: Number(serviceId), quantity: quantity, properties: { _corte_grupo: groupId, _servicio: 'corte_a_cuchillo', _producto: form.dataset.productTitle || '' } }
      ]
    };

    try {
      const response = await fetch(form.dataset.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error('cart');

      window.location.href = form.dataset.cartUrl;
    } catch (error) {
      if (errorMessage) errorMessage.hidden = false;
      if (submitButton) submitButton.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
